import { useEffect, useState } from 'react';

const useQuestions = (questionnaireId) => {
  const [questions, setQuestions] = useState([]);
  const [responseTimeLimit, setResponseTimeLimit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchQuestionnaire = async () => {
      try {
        const response = await fetch(`https://contest.new-waay.com/survey/questionnaires/${questionnaireId}/`);
        if (response.ok) {
          const data = await response.json();
          setQuestions(data.questions);
          setResponseTimeLimit(data.response_time_limit);
        } else {
          throw new Error('Failed to fetch questionnaire data');
        }
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestionnaire();
  }, [questionnaireId]);

  return { questions, responseTimeLimit, loading, error };
};

export default useQuestions;
